export const gdsc_api_base_url = "https://www.cancerrxgene.org";
export const api_base_url = window.location.protocol + "//api." + window.location.host;
//export const api_base_url = "http://api.cmp.staging.team215.sanger.ac.uk";
//export const api_base_url = "http://127.0.0.1:5000";

